export * from "Search/Scenarios/Shared/Components/ResultsInfo/ResultsInfo";
export * from "Search/Scenarios/Shared/Components/ResultsInfo/ResultsInfo.Props";
